import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateUtilsService {
  constructor() {}

  public getDifferenceInDays(date1: number, date2: number) {
    const difference = date2 - date1;
    return Math.floor(difference / 86400000);
  }

  public getDifferenceInDaysFromNow(date: number) {
    const now = new Date();
    return this.getDifferenceInDays(date, now.getTime());
  }

  public isLessThanOrEqualToDifference(
    date1: number,
    date2: number,
    days: string
  ) {
    const differenceInDaysFromNow = this.getDifferenceInDays(date1, date2);
    return (
      differenceInDaysFromNow > 0 && differenceInDaysFromNow <= parseInt(days)
    );
  }

  public isLessThanOrEqualToDifferenceFromNow(date: number, days: string) {
    const differenceInDaysFromNow = this.getDifferenceInDaysFromNow(date);
    const differenceFromIndicator =
      differenceInDaysFromNow > 0 && differenceInDaysFromNow <= parseInt(days);
    return differenceFromIndicator;
  }
}
